export default "__VITE_ASSET__DBLsu4fQ__"